import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "article",
    {
      staticClass:
        "specialization-item rounded-20 d-flex flex-column justify-space-between ga-1 text-break",
      class: {
        "specialization-item--primary": _vm.isPrimary,
      },
      attrs: { "data-qa": "specialization_item" },
    },
    [
      _c("div", { staticClass: "d-flex flex-column ga-2" }, [
        _c(
          "h3",
          {
            staticClass: "text-h6",
            attrs: { "data-qa": "specialization_item_name" },
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.specialization.speciality.name) + "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "text-body-2",
            attrs: { "data-qa": "specialization_item_description" },
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.specialization.description) + "\n    "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex align-end justify-space-between" },
        [
          _c(
            VBtn,
            {
              staticClass: "branding-btn rounded-20 px-4 align-self-end",
              class: _vm.isPrimary
                ? "branding-btn--white"
                : "branding-btn--primary",
              attrs: {
                depressed: "",
                "data-qa": "specialization_item_btn",
                height: "52",
                href: _setup.getSpecializationHref(
                  _vm.specialization.speciality.id
                ),
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.textBtn) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "specialization-item__image-container" },
            [
              _vm.specialization.speciality.icon?.url
                ? _c(_setup.MaskIcon, {
                    staticClass: "specialization-item__image",
                    attrs: {
                      src: _vm.specialization.speciality.icon.url,
                      size: 150,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }